import { useState } from 'react'

import { getWaFlowLengthError } from '../wa-flow-editor-utils'

export const useWaFlowFieldError = (value: string, maxLength: number, initiallyVisible: boolean) => {
  const [visible, setVisible] = useState(initiallyVisible)
  const error = visible ? getWaFlowLengthError(value, maxLength) : ''
  return [error, () => setVisible(true)] as const
}
